export const getFirstMatchingStringFromAnotherArray = ({
  arrayToMatch,
  targetArray
}) => arrayToMatch?.find((item) => targetArray?.includes(item)) || ''
